import { SVGProps } from 'react'

export const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={16}
		height={16}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M13.532 3.93a1.02 1.02 0 0 1 0 1.417l-6.56 6.723a.96.96 0 0 1-1.382 0l-3.122-3.2a1.02 1.02 0 0 1 0-1.417.96.96 0 0 1 1.383 0l2.43 2.492L12.15 3.93a.96.96 0 0 1 1.383 0"
			fill="currentColor"
		/>
	</svg>
)
